<template>
  <div
    class="w-fit font-primary font-medium text-[14px] text-green-700 cursor-pointer flex items-center"
  >
    <slot />
    <Icon :size="props.iconSize" class="ml-1 align-middle" name="LinkArrow" />
  </div>
</template>

<script setup lang="ts">
import { Icon } from '@dacr/ui'

const props = withDefaults(
  defineProps<{
    iconSize?: number
  }>(),
  {
    iconSize: 13,
  }
)
</script>
